import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { useDispatch, useSelector } from 'react-redux';
import { ENV } from 'src/constants';
import { useEnv, useSwitchEnv } from 'src/hooks';
import { loadCallbackUrl } from 'src/pages/Settings/DeveloperOptions/redux/actions';
import { RootState } from 'src/redux/reducers/rootReducer';
import { storage } from 'src/utilities/Storage';

export const useEnvSwitcherImpl = () => {
  const username = useSelector(
    (state: RootState) => state.auth.user?.username || '',
  );
  const dispatch = useDispatch();

  const { switchProduction, switchToDemo } = useSwitchEnv();
  const { isProdEnv } = useEnv();

  const onSwitcherValueChanged = async (env: string) => {
    if (env === ENV.STAGING) {
      await switchToDemo(username);
    } else {
      await switchProduction();
      storage.set('triggerUpgradeReminder', true);
    }
    dispatch(loadCallbackUrl());
  };

  const trackEnvChanges = (env: string) => {
    AnalyticsManager.instance().track(AnalyticsEvent.environment_button, {
      type: env,
    });
  };

  const onClick = () => {
    const nextEnv = isProdEnv ? ENV.STAGING : ENV.PRODUCTION;
    onSwitcherValueChanged(nextEnv);
    trackEnvChanges(nextEnv);
  };

  const buttonLabel = isProdEnv
    ? 'envSwitcher_productionLabel'
    : 'envSwitcher_demoLabel';

  const state = { buttonLabel, isProdEnv };

  return { state, onClick };
};
